import React, { useState, useEffect, useRef } from 'react'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header'
import CustomTable from '../../components/shared/CustomTable';
import Search from '../../components/shared/Search';
import CustomSelect from '../../components/shared/CustomSelect';

import './ManifestHistoryDetail.scss'
import manifestAPI from '../../api/manifestAPI';
import { useParams, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loadingActions } from '../../redux/actions';
import moment from 'moment';
import enterprisesAPI from '../../api/enterprisesAPI';
import storesAPI from '../../api/storesAPI';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const columns = [
  { id: 'manifestId', label: 'Manifiesto', minWidth: 400 },
  { id: 'orderNumber', label: 'N° Pedido', minWidth: 150 },
  { id: 'ticket', label: 'Ticket', minWidth: 100 },
  { id: 'guideNumber', label: 'Guía', minWidth: 150 },
  { id: 'cudsNumber', label: 'CUDs', minWidth: 80},
  { id: 'itemsNumber', label: 'Items', minWidth: 80 },
  { id: 'storeName', label: 'Sucursal', minWidth: 150 },
  { id: 'companyName', label: 'Empresa', minWidth: 200 },
  { id: 'carPlate', label: 'N° Placa', minWidth: 100 },
  { id: 'dni', label: 'DNI', minWidth: 120 },
  { id: 'carrier', label: 'Transportista', minWidth: 350 },
]

const ManifestHistoryDetail = () => {

  const [filters, setFilters] = useState({
    enterprises:[],
    stores:[],
  })
  const [companiesOption, setCompaniesOption] = useState([
    {
      label: 'Empresas',
      options: [],
    },
  ])
  const [storesOption, setStoresOption] = useState([
    {
      label: 'Sucursal',
      options: [],
    },
  ])
  const [modalSession, setModalSession] = useState(false)
  const [textSearch, setTextSearch] = useState('')
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(4);
  const [total, setTotal] = useState(20);
  const [perPage, setPerPage] = useState(10);
  const [rows, setRows] = useState([])
  const params = useParams();
  const { state: { manifest, filters:paramFilters } } = useLocation();
  const date = params.id;
  const didMounRef = useRef(false);
  const didMounRef2 = useRef(false);
  const didMounRef3 = useRef(false);
  // console.log(manifest)

  useEffect(() => {
    setFilters(paramFilters);
    // fetchManifestDetail(currentPage, perPage);
    fetchCompanies();
    fetchStores();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if(didMounRef.current) onChangePerPage(perPage);
        else didMounRef.current = true;
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [perPage]);

  useEffect(() => {
    if(didMounRef3.current) onChangePerPage(perPage);
    else didMounRef3.current = true;
    // eslint-disable-next-line
  }, [filters])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if(didMounRef2.current) onChangePerPage(perPage);
      else didMounRef2.current = true;
    }, 1000);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [textSearch])

  const formatFilters = ({textSearch, stores, enterprises }) => {
    const newFilters = {
      textSearch,
      stores: Array.isArray(stores) ? stores : [stores],
      enterprises: Array.isArray(enterprises) ? enterprises : [enterprises],
    }
    return newFilters
  }

  const fetchManifestDetail = async (currentPage, perPage) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const { total, purchaseOrders } = await manifestAPI.getHistoryDetail(date, currentPage, perPage, formatFilters({...filters, textSearch}));
      console.log(total, purchaseOrders);
      setRows(purchaseOrders)
      setTotal(total)
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      }
    }
  }

  const fetchCompanies = async () => {
    try {
      const companies = await enterprisesAPI.getEnterprises();
      console.log(companies, 'COMPANIES')
      const formatCompanies = companies.map( c => ({...c, value: c.id, label: c.name}))
      setCompaniesOption([{
        label: 'Empresas',
        options: formatCompanies,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const fetchStores = async () => {
    try {
      const stores = await storesAPI.getStores();
      console.log(stores, 'stores')
      const formatStores = stores.map( s => ({...s, value: s.id, label: s.name}))
      setStoresOption([{
        label: 'Sucursal',
        options: formatStores,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      }
    }
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    fetchManifestDetail(numPage, perPage)
  }

  const onChangePerPage = async (perPage) => {
    if(perPage <= 0) return;
    setCurrentPage(1);
    await fetchManifestDetail(1, perPage)
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      <div className='manifest-history-detail-container'>
        <Header
          title='Manifiestos / Historial de manifiestos'
          subtitle={moment.utc(date).format('ddd [  ]DD MMM YYYY')}
          // onClickBtn1={() => console.log('object')}
          // iconBtn1={ExcelIcon}
          // btnTitle1='Exportar'
          // btnTitle2='Enviar'
          // onClickBtn2={() => console.log('object')}
          // iconBtn2={SendIcon}
        />
        <div className='manifest-history-detail-subheader'>
          <div className='manifest-history-detail-subheader-row'>
            <div className='manifest-history-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_web_clipboard-alt-gray.svg')} alt='clipboard' />
              <span><span style={{fontWeight: 500}}>{manifest.manifestsCount}</span> manifiestos creados</span>
            </div>
            <div className='manifest-history-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_papper-check.svg')} alt='pappercheck' />
              <span><span style={{fontWeight: 500}}>{manifest.ticketsNumber}</span> tickets escaneados</span>
            </div>
          </div>
        </div>
        <div className='manifest-history-detail-filters'>
          <div className='manifest-history-detail-search'>
            <Search
              placeholder='N° Pedido, Ticket o Guía'
              value={textSearch}
              onChange={text => setTextSearch(text)}
            />
          </div>
          <div className='manifest-history-detail-select company'>
            <CustomSelect
              value={filters.enterprises}
              onChange={(e) => setFilters({...filters, enterprises:e})}
              placeholder='Empresas'
              options={companiesOption}
              multi
            />
          </div>
          <div className='manifest-history-detail-select location'>
            <CustomSelect
              value={filters.stores}
              onChange={(e) => setFilters({...filters, stores:e})}
              placeholder='Sucursales'
              options={storesOption}
              multi
            />
          </div>
        </div>
        <div className='manifest-history-detail-table'>
          <CustomTable
            columns={columns}
            rows={rows}
            // onChangeNumElem={(num) => onChangePerPage(num)}
            total={total}
            currentPage={currentPage}
            changePage={onChangePage}
            perPage={perPage}
            onChangePerPage={(e) => setPerPage(e.target.value)}
            totalPages={totalPages}
          />
        </div>
      </div>
    </Layout>
  )
}

export default ManifestHistoryDetail
